import Vue from 'vue';
import WidgetEventResourceModel from '../../generated/types/model/resource/WidgetEventResourceModel';
import { getAvailabilityString } from './WidgetEventListResourceViewModel';

export default class WidgetEventResourceViewModel extends WidgetEventResourceModel {
  public get availabilityString():string {
    return getAvailabilityString(this.registrationStatus);
  }
  public get costs():string {
    if (Vue._.isSet(this.dto.costs)) { return this.dto.costs; }
    if (this.price === undefined) { return Vue.$t('widget.events.noCosts'); }
    return Vue.$format.currency(this.price!)!;
  }
  public get hasDocuments():boolean {
    if (this.eventDocumentsUrl != null || this.locationMapUrl != null || this.eventInformationDocumentUrl != null) {
      return true;
    }
    return false;
  }
}
